import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Helmet } from 'react-helmet';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Hdashboard from '../../../components/Hdashboard';
import JqueryLoad from '../../../JqueryLoad/JqueryLoad';
import { convertToBase64, TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/common.service';
import { uploadImageOnAWS } from '../../aws/Service';
import { addNewsLetter, previewNewsLetter } from '../../../api/apiHandler';
import { Button, Modal } from "react-bootstrap";
import Select from 'react-select';

const panelOptions = [
    { label: 'Landing Page', value: 'landing_page' },
    { label: 'Teacher', value: 'teacher' },
    { label: 'Organization', value: 'organization' },
    { label: 'Organization Teacher', value: 'org_teacher' },
    { label: 'Parents', value: 'below_18' },
    { label: 'Kids', value: 'learner' },
    { label: 'Over 18', value: 'above_18' },
    { label: 'Schools-After School Centers', value: 'after_school' },
    { label: 'Unregistered Users', value: 'unregistered' },
];

const Editor = ({ content, onChange }) => {
    return (
        <ReactQuill
            value={content}
            onChange={onChange}
            modules={Editor.modules}
            formats={Editor.formats}
            theme="snow"
            placeholder="Write something..."
            style={{ borderRadius: '10px' }}
        />
    );
};

Editor.modules = {
    toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean'],
    ],
};

Editor.formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'link',
    'image',
];

// With a scheme any address the browser can parse is fine (localhost, IPs, ports);
// without one it must look like a domain, since it gets "https://" prepended on save
const isValidUrl = (value) => {
    const trimmed = (value || '').trim();
    if (!trimmed) return true;
    if (/\s/.test(trimmed)) return false;
    if (/^https?:\/\//i.test(trimmed)) {
        try {
            return Boolean(new URL(trimmed).hostname);
        } catch {
            return false;
        }
    }
    return /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?([\/?#].*)?$/.test(trimmed);
};

const getVideoThumbnail = (file) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.load();

        // Wait for the video metadata to load
        video.addEventListener('loadeddata', () => {
            // Set the current time to a point in the video (e.g., 5 seconds)
            video.currentTime = 5;
        });

        video.addEventListener('seeked', () => {
            // Create a canvas element to capture the video frame
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const context = canvas.getContext('2d');
            if (context) {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                const dataUrl = canvas.toDataURL('image/png');
                resolve(dataUrl);
            } else {
                reject(new Error('Failed to create canvas context.'));
            }

            // Clean up the object URL
            URL.revokeObjectURL(video.src);
        });

        video.addEventListener('error', (e) => {
            console.error('Video error:', e);
            reject(e);
        });
    });
};

export default function AddNewsLetter({ isLoader }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const [sendNow, setSendNow] = useState(true);
    const [scheduleDate, setScheduleDate] = useState('');
    const [scheduleTime, setScheduleTime] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [AttachmentData, setAttachmentData] = useState({});
    const [previewData, setPreviewData] = useState(null);
    const [profileImageState, setProfileImageState] = useState('');
    const [profileImageState1, setProfileImageState1] = useState('');
    const [showName, setShowName] = useState({});

    const [selectedPanels, setSelectedPanels] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [panelError, setPanelError] = useState('');

    const handleSelectAllChange = (e) => {
        setSelectAll(e.target.checked);
        if (e.target.checked) {
            setSelectedPanels(panelOptions.map(o => o.value));
        } else {
            setSelectedPanels([]);
        }
        setPanelError('');
    };

    const handlePanelChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(o => o.value) : [];
        setSelectedPanels(values);
        setSelectAll(values.length === panelOptions.length);
        setPanelError('');
    };

    var schema = yup.object().shape({
        newsletter_title: yup.string().required('Newsletter title is required'),
        newsletterdata: yup.array().of(
            yup.object().shape({
                title: yup.string().trim().required('Title is required').max(255, 'Title must be at most 255 characters'),
                description: yup.string().required('Description is required'),
                url: yup
                    .string()
                    .nullable()
                    .notRequired()
                    .test('is-url', 'Invalid URL', (value) => isValidUrl(value)),
                attachments: yup.array().of(
                    yup.object().shape({
                        attachments: yup.string().required('Attachment URL is required'),
                        attachment_type: yup.string().required('Attachment type is required'),
                        thumb_image: yup.string().nullable() // Make sure this is nullable if not always required
                    })
                ).min(1, 'At least one attachment is required').nullable()
            })
        ).required('At least one description is required')
    });
    if (!sendNow) {
        schema = schema.shape({
            schedule_date: yup.date()
                .transform((value, originalValue) => originalValue === '' ? null : value)
                .required('Schedule date is required')
                .min(new Date(), 'Date must be in the future'),
            schedule_time: yup.string()
                .transform((value, originalValue) => originalValue === '' ? null : value)
                .required('Schedule time is required')
        });
    } else {
        schema = schema.shape({
            schedule_date: yup.date()
                .nullable()
                .transform((value, originalValue) => originalValue === '' ? null : value),
            schedule_time: yup.string()
                .nullable()
                .transform((value, originalValue) => originalValue === '' ? null : value)
        });
    }

    const { register, handleSubmit, setValue, clearErrors, reset, watch, control, getValues, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            newsletterdata: [{ title: '', description: '', url: '', attachments: [] }]
        }
    });

    console.log('errors :', errors);

    const handleImageChange = async (image, Attachment_Index, fileIndex, type) => {
        setShowName(image.name);

        if (image) {
            TOAST_SUCCESS('Your attachment has been uploaded!');
        }

        let str = 'attachment_' + Attachment_Index;
        let temp_arr = { ...AttachmentData }; // Create a copy of the state
        console.log('AttachmentData :', AttachmentData);

        try {
            if (type === 'video') {
                const thumbnailDataUrl = await getVideoThumbnail(image);
                const thumbnailBlob = await fetch(thumbnailDataUrl).then(res => res.blob());
                const thumbnailFile = new File([thumbnailBlob], 'thumbnail.png', { type: 'image/png' });

                let video_name = await uploadImageOnAWS(image, 'newsletter_attachments');
                let thumbnail_name = await uploadImageOnAWS(thumbnailFile, 'newsletter_thumbnails');

                if (!temp_arr[str]) {
                    temp_arr[str] = [];
                }
                temp_arr[str][fileIndex] = { attachments: video_name, attachment_type: type, thumb_image: thumbnail_name };
            } else {
                let image_name = await uploadImageOnAWS(image, 'newsletter_attachments');
                if (!temp_arr[str]) {
                    temp_arr[str] = [];
                }
                temp_arr[str][fileIndex] = { attachments: image_name, attachment_type: type };
            }

            // Update the AttachmentData state without affecting description validation
            setAttachmentData(temp_arr);
            setValue('newsletterdata', newsletterDetails.map((item, index) => ({
                ...item,
                attachments: temp_arr[`attachment_${index}`] || item.attachments,
            })));

            // Ensure description errors are not cleared
            if (errors.newsletterdata) {
                clearErrors('newsletterdata');
            }

        } catch (error) {
            console.error('Error handling attachment:', error);
        }

        // Set profile image states if needed
        const bufferImage = await convertToBase64(image);
        if (fileIndex === 0) {
            setProfileImageState(bufferImage);
        } else {
            setProfileImageState1(bufferImage);
        }
        clearErrors('attachments_data');
    };

    const handleImageChange1 = async (image) => {
        if (image != null) {
            TOAST_SUCCESS('Your attachment has been uploaded!');
        }
        setValue('attachments_data1', image);
        const bufferImage = await convertToBase64(image);
        setProfileImageState1(bufferImage);
        clearErrors('attachments_data1');
    };

    const onSubmit = async (data) => {
        console.log('data :', data);

        if (selectedPanels.length === 0) {
            setPanelError('Please select at least one panel');
            return;
        }

        let coupon_data = {
            title: data.newsletter_title,
            panels: selectedPanels,
            send_time: sendNow ? "now" : "schedule",
            ...(sendNow === false && {
                schedule_date: scheduleDate,
                schedule_time: scheduleTime
            })
        };

        coupon_data.newsletterdata = buildNewsletterData();
        isLoader(true)
        addNewsLetter(coupon_data).then((res) => {
            console.log('res :', res);
            if (res?.code == 1) {
                TOAST_SUCCESS(res.message);
                navigate('/news_letter');
                isLoader(false)
            } else {
                TOAST_ERROR(res.message);
                isLoader(false)
            }
        });
        reset();
    };

    const [newsletterDetails, setnewsletterDetails] = useState([{ title: '', description: '', attachment: null, url: '' }]);

    const handleTitleChange = (index, value) => {
        const updatednewsletterDetails = [...newsletterDetails];
        updatednewsletterDetails[index].title = value;
        setnewsletterDetails(updatednewsletterDetails);
    };

    const handleDescriptionChange = (index, value) => {
        const updatednewsletterDetails = [...newsletterDetails];
        updatednewsletterDetails[index].description = value;
        setnewsletterDetails(updatednewsletterDetails);
    };

    const handleUrlInputChange = (index, value) => {
        const updatednewsletterDetails = [...newsletterDetails];
        updatednewsletterDetails[index].url = value;
        setnewsletterDetails(updatednewsletterDetails);
    };

    const handleAttachmentChange = (index, file) => {
        const updatednewsletterDetails = [...newsletterDetails];
        updatednewsletterDetails[index].attachment = file;
        setnewsletterDetails(updatednewsletterDetails);
    };

    const handleAddDescription = () => {
        setnewsletterDetails([...newsletterDetails, { title: '', description: '', attachment: null, url: '' }]);
    };

    // Email links need a scheme, otherwise "www.example.com" becomes a broken relative link
    const normalizeUrl = (url) => {
        const trimmed = (url || '').trim();
        if (!trimmed) return '';
        return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    };

    // Shared by "Create Newsletter" and "Preview" so the preview renders exactly what will be sent
    const buildNewsletterData = () => newsletterDetails.map((lesson, index) => {
        const attachments = (AttachmentData[`attachment_${index}`] || []).filter(item => item && item.attachments);
        return {
            title: (lesson.title || '').trim(),
            description: lesson.description,
            link: normalizeUrl(lesson.url),
            attachments: attachments.map(item => ({
                attachments: item.attachments,
                attachment_type: item.attachment_type,
                thumb_image: item.thumb_image
            }))
        };
    });

    const handleShowModal = () => {
        setPreviewData(null);
        setShowModal(true);
        previewNewsLetter({
            title: getValues('newsletter_title') || '',
            newsletterdata: buildNewsletterData()
        }).then((res) => {
            if (res?.code == 1) {
                setPreviewData(res.data?.html || '');
            } else {
                setShowModal(false);
                TOAST_ERROR(res?.message);
            }
        });
    };

    const handleClose = () => setShowModal(false);

    return (
        <>
            <JqueryLoad />
            <Hdashboard />
            <Helmet>
                <style>
                    {`
          .form-control:disabled, .form-control[readonly] {
            background-color: #ffffff;
            opacity: 1;
          }
          `}
                </style>
            </Helmet>
            <main>
                <div className="dashboard-app d-lg-flex">
                    <header className="dashboard-toolbar d-lg-none d-flex justify-content-between">
                        <div className="align-items-center justify-content-between d-flex">
                            <div className="d-flex align-items-center">
                                <a href="#!" className="menu-toggle align-items-center d-lg-none d-flex">
                                    <i className="fa fa-bars" />
                                </a>
                                <a href="#" className="d-lg-none d-block brand-logo">
                                    <img src="./assets/images/logo.png" alt="logo" />
                                </a>
                            </div>
                        </div>
                    </header>
                    <div className="class-content">
                        <div>
                            <a onClick={() => navigate(-1)} className="mb-4 arrow_left mb-3 d-block" >
                                <span>
                                    <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" />
                                    </svg>
                                    <span className="ms-2">Back</span>
                                </span>
                            </a>
                            <div className="row">
                                <div className="col-xl-8 mx-4">
                                    <div className="mb-4">
                                        <p className="d-flex fs-3 fw-600">Add Newsletter</p>

                                    </div>
                                    <div className='card border-purple p-4 mb-3'>
                                        <form onSubmit={handleSubmit(onSubmit)} className="custom_form">
                                            <div className="form-group mb-4">
                                                <label className="form-label">Add Newsletter Title</label>
                                                <div className="position-relative class_title">
                                                    <input
                                                        type="text"
                                                        {...register('newsletter_title')}
                                                        maxLength={100}
                                                        name="newsletter_title"
                                                        className="form-control"
                                                        placeholder="Newsletter Title"
                                                    />
                                                    <span className="position-absolute word_count">
                                                        {100 - (watch('newsletter_title')?.split('')?.length ?? 0)} Words
                                                    </span>
                                                    <p className="mt-2 font-bold col-red">
                                                        <span style={{ color: 'red' }}>{errors.newsletter_title?.message}</span>
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Panels Multi-Select */}
                                            <div className="form-group mb-4">
                                                <label className="form-label">In which side you want to show this Newsletter:</label>
                                                {!selectAll && (
                                                    <Select
                                                        options={panelOptions}
                                                        required
                                                        value={panelOptions.filter(o => selectedPanels.includes(o.value))}
                                                        className='mt-2'
                                                        onChange={handlePanelChange}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        placeholder="Select Panels..."
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                border: '1px solid rgba(102, 102, 102, 0.35)',
                                                                borderRadius: '12px',
                                                                padding: '5px 10px',
                                                                minHeight: '46px',
                                                            }),
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999,
                                                            }),
                                                        }}
                                                    />
                                                )}
                                                {panelError && (
                                                    <div className="text-danger mt-1">{panelError}</div>
                                                )}
                                                {selectAll && (
                                                    <input
                                                        type="text"
                                                        className="form-control py-2 mt-2"
                                                        placeholder="All are selected"
                                                        readOnly
                                                        style={{ borderRadius: "12px" }}
                                                    />
                                                )}
                                                <div className="form-check mt-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id="selectAllBlog"
                                                        checked={selectAll}
                                                        onChange={handleSelectAllChange}
                                                    />
                                                    <label className="form-check-label text-secondary" htmlFor="selectAllBlog">Select All Panels</label>
                                                </div>
                                            </div>
                                            {newsletterDetails.map((lesson, index) => (
                                                <div key={index}>
                                                    <div className="form-group mb-4">
                                                        <label className="form-label">Add Title</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={255}
                                                            placeholder="Enter title"
                                                            {...register(`newsletterdata.${index}.title`, {
                                                                onChange: (e) => handleTitleChange(index, e.target.value)
                                                            })}
                                                        />
                                                        <p className="mt-2 font-bold col-red">
                                                            <span style={{ color: 'red' }}>{errors.newsletterdata?.[index]?.title?.message}</span>
                                                        </p>
                                                    </div>

                                                    <div className="form-group mb-4">
                                                        <label className="form-label">Add Newsletter Description</label>
                                                        <div className="position-relative class_summary">
                                                            <Controller
                                                                name={`newsletterdata.${index}.description`}
                                                                control={control}
                                                                defaultValue=""
                                                                render={({ field }) => (
                                                                    <Editor
                                                                        content={field.value}
                                                                        onChange={(value) => {
                                                                            field.onChange(value);
                                                                            handleDescriptionChange(index, value);
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            <p className="mt-2 font-bold col-red">
                                                                <span style={{ color: 'red' }}>{errors.newsletterdata?.[index]?.description?.message}</span>
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="form-group mb-4 attach_box">
                                                        <label className="form-label">Add Attachments</label>
                                                        <div className="position-relative">
                                                            <textarea type="text" className="form-control" rows={1} value={AttachmentData[`attachment_${index}`]
                                                                ?.filter(item => item.attachments)
                                                                .map(item => item.attachments)
                                                                .join('\n')}
                                                                readOnly
                                                            />
                                                            <div className="att_icon_list position-absolute">
                                                                <ul className="d-flex align-items-center justify-content-end">
                                                                    <li>
                                                                        <label htmlFor={`attach1_${index}`}>
                                                                            <a>
                                                                                <img src="./assets/images/attach1.png" alt="attach1" />
                                                                            </a>
                                                                        </label>
                                                                        <input type="file" id={`attach1_${index}`} onInput={(e) => {
                                                                            const file = e.target.files[0];
                                                                            const fileType = file.type.startsWith('image') ? 'image' : 'video';
                                                                            handleImageChange(file, index, 0, fileType);
                                                                        }} {...register("attachments")} accept="image/*,video/*" className="file-input" style={{ "visibility": "hidden", "display": "none" }} />

                                                                    </li>
                                                                    <li>
                                                                        <label htmlFor={`attach2_${index}`}>
                                                                            <a >
                                                                                <img src="./assets/images/attach2.png" alt="attach2" />
                                                                            </a>
                                                                        </label>
                                                                        <input type="file" id={`attach2_${index}`} {...register("attachments")} onInput={(e) => handleImageChange(e.target.files[0], index, 1, "video")} accept="video/*" className="file-input" style={{ "visibility": "hidden", "display": "none" }} />

                                                                    </li>
                                                                    <li>
                                                                        <label htmlFor={`attach3_${index}`}>
                                                                            <a>
                                                                                <img src="./assets/images/attach3.png" alt="attach3" />
                                                                            </a>
                                                                            <input type="file" id={`attach3_${index}`}  {...register("attachments")} accept="image/*" onInput={(e) => handleImageChange(e.target.files[0], index, 2, "image")} className="file-input" style={{ "visibility": "hidden", "display": "none" }} />
                                                                        </label>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <p className="mt-2 font-bold col-red">
                                                            <span style={{ color: 'red' }}>
                                                                {errors.newsletterdata?.[index]?.attachments?.message}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="form-group mb-4">
                                                        <label className="form-label">Add URL (Optional)</label>
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter URL"
                                                                {...register(`newsletterdata.${index}.url`, {
                                                                    onChange: (e) => handleUrlInputChange(index, e.target.value)
                                                                })}
                                                            />
                                                        </div>
                                                        <p className="mt-2 font-bold col-red">
                                                            <span style={{ color: 'red' }}>{errors.newsletterdata?.[index]?.url?.message}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="d-flex justify-content-end mt-3">
                                                <a className="text-decoration-underline text-purple" onClick={handleAddDescription}>
                                                    + Add another Title and Description
                                                </a>
                                            </div>

                                            <div className="form-group mb-4">
                                                <label className="form-label mb-2">When should we send this email?</label>
                                                <div>
                                                    <div className="form-check mb-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value="now"
                                                            checked={sendNow}
                                                            onChange={() => setSendNow(true)}
                                                        />
                                                        <label className="form-check-label ms-2 mt-1">
                                                            Send Now
                                                        </label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            value="schedule"
                                                            checked={!sendNow}
                                                            onChange={() => setSendNow(false)}
                                                        />
                                                        <label className="form-check-label ms-2 mt-1">
                                                            Schedule a Time
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {!sendNow && (
                                                <div className="form-group mb-4">
                                                    <label className="form-label">Select Date and Time</label>
                                                    <div className="d-flex flex-column flex-md-row align-items-start">
                                                        <div className="col-md-3 mb-3 mb-md-0">
                                                            <div className="input-group">
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    {...register('schedule_date')}
                                                                    onChange={(e) => {
                                                                        setScheduleDate(e.target.value);
                                                                        clearErrors("schedule_date");
                                                                    }}
                                                                    min={new Date().toISOString().split("T")[0]} // Disable past dates
                                                                />
                                                            </div>
                                                            {errors.schedule_date && (
                                                                <div>
                                                                    <span style={{ color: 'red' }} className="mt-2">{errors.schedule_date.message}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-md-3 ms-3">
                                                            <div className="input-group">
                                                                <input
                                                                    type="time"
                                                                    className="form-control"
                                                                    {...register('schedule_time')}
                                                                    onChange={(e) => {
                                                                        const timeValue = e.target.value;
                                                                        const formattedTime = `${timeValue}:00`; // Add seconds as 00
                                                                        setScheduleTime(formattedTime);
                                                                        clearErrors("schedule_time");
                                                                    }}
                                                                    min={scheduleDate === new Date().toISOString().split("T")[0]
                                                                        ? new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
                                                                        : '00:00'} // Disable past times if current date is selected
                                                                />
                                                            </div>
                                                            {errors.schedule_time && (
                                                                <div>
                                                                    <span style={{ color: 'red' }} className="mt-2">{errors.schedule_time.message}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="button mt-5 d-flex">
                                                <span className="btn-theme bg-yellow text-center fw-600 d-block" onClick={handleShowModal}>
                                                    Preview
                                                </span>
                                                <button className="btn-theme bg-yellow text-center fw-600 d-block ms-3" >
                                                    Create Newsletter
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Modal show={showModal} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Preview Newsletter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {previewData === null ? (
                        <p className="text-center text-muted my-5">Loading preview...</p>
                    ) : (
                        // The email HTML is rendered in an iframe so admin-panel styles don't change how it looks
                        <iframe
                            title="Newsletter email preview"
                            srcDoc={previewData}
                            sandbox="allow-popups allow-popups-to-escape-sandbox"
                            style={{ width: '100%', height: '75vh', border: 0, display: 'block' }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}

